import { render } from "./view_trading.vue?vue&type=template&id=540a6d1b"
import script from "./view_trading.vue?vue&type=script&lang=js"
export * from "./view_trading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__